import React, {useState, useEffect} from 'react';
import html2canvas from 'html2canvas';
import Time from '../Time';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap'

class ScreenShot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        displayMediaOptions: { 
          video: {cursor: "always"},
          audio: false
        },
        streamStatus: false,
        streamSharing: "",
        streamInfo:{},
        shiftId:0,
        randomNumber:0,
        count:0,
        min:5,
        max:15,
        quality:100
    };
    this.startCapture = this.startCapture.bind(this);
    this.videoElem = React.createRef();
    this.screenShotOnline = this.screenShotOnline.bind(this);
    this.checkStreamInfo = this.checkStreamInfo.bind(this);
    this.setInitialValues = this.setInitialValues.bind(this);
  }

  componentDidMount = () =>{
    this.loadScreenshotSettings()
  }
  
  loadScreenshotSettings = async() =>{

  var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };
    
  await fetch("https://dashboard.realsexdoll.info/php/users/userssettings.php", requestOptions)
    .then(response => response.json())
    .then(result => 
        this.setInitialValues(result)
    )
    .catch(error => console.log('error', error));
    
  }
  /**
   * Gets the settings from the database and insert on the screenshots settings
   * @param  {} results
   */
  setInitialValues = (results)=>{
    
    let minimumVal = parseInt(results[0].numberValue)
    let maximumVal = parseInt(results[1].numberValue)
    let setQuality = parseInt(results[2].numberValue)

      this.setState({min:minimumVal})
      this.setState({max:maximumVal})
      this.setState({quality:setQuality})
      console.log('Settings Loaded');

      if(this.state.randomNumber == 0){
        let newRandom = this.getRndInteger(minimumVal,maximumVal);
        this.setState({randomNumber:newRandom});
        console.log('First Random Number:'+ newRandom)
      }
  
  }

  startCapture = async () =>{
    const videoHTML = this.videoElem.current;
    try {
          videoHTML.srcObject = await navigator.mediaDevices.getDisplayMedia(this.state.displayMediaOptions);
          this.setState({streamStatus:true})
          this.setState({screenShotInterval:setInterval(() => { this.screenShotOnline(); }, 1*60*1000)})
        } catch (err) {
          console.error(`Error: ${err}`);
        }
  }

  // Makes the website stop looking at user`s screen
  stopCapture = () => {
    const videoHTML = this.videoElem.current;
    let tracks = videoHTML.srcObject.getTracks();
    tracks.forEach((track) => track.stop());
    videoHTML.srcObject = null;
    clearInterval(this.state.screenShotInterval)
  }

  // Checks if the user is really sharing the screen and returns a result
  checkStreamInfo = () =>{
    const streamHTML = this.videoElem.current.srcObject;
    const streamStatusState = this.state.streamInfo;
  
    if(streamHTML == null){
      this.setState({streamSharing:"Stream Not Active"})
      return "Stream not Active"
    }else if (streamHTML.active == false){
      return "Stream not Active"
    }else if (streamHTML.getVideoTracks()[0].getSettings().displaySurface != "monitor"){
      this.stopCapture();
      return "Stream Active but not monitor"
    }else{
      return "Stream Active and normal"
    }
    
  }

  
  /**
   * Returns a random number between a minimum and maximum
   * @param  {} min
   * @param  {} max
   */
  getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  /**
   * Takes a screenshot and upload it to a server
   */
  screenShotOnline = () => {

    if(this.state.count < this.state.randomNumber){
      let number = this.state.count;
      number += 1;
      this.setState({count:number})
      console.log('Count: '+number);
      console.log('Random number: '+this.state.randomNumber);
      return;
    }else{

      let quality = this.state.quality/100

      let dateTime = Time.getComputerTimeDate();
      let month = Time.getMonth();
      let shiftId = localStorage.getItem("shiftId");

      const screenshotTarget = this.videoElem.current;

        html2canvas(screenshotTarget).then((canvas) => {
          
          // (A) APPEND SCREENSHOT TO DATA OBJECT
          var data = new FormData();
          data.append("screenshot", canvas.toDataURL("image/jpeg", quality))
          data.append("dateTime",dateTime);
          data.append("month",month);
          data.append("shiftId",shiftId);
          data.append("user", this.props.user);

          // (B) UPLOAD SCREENSHOT TO SERVER
          fetch("https://dashboard.realsexdoll.info/php/timesheet/uploadscreenshot.php", { method:"post", body:data })
          .then((res) => { return res.text(); })
          .then((txt) => { console.log(txt); });

        });

      this.setState({count:0})
      let newRandom = this.getRndInteger(this.state.min,this.state.max);
      this.setState({randomNumber:newRandom});

    }
    
  }

  render() {
    return(
        <div id='screenshot-holder'>
            <h2>{this.props.title}</h2>
            <p>This example shows you the contents of the selected part of your display.
            Click the Start Capture button to begin.</p>
            <p>
              <button onClick={this.startCapture} id="start">Start Capture</button>&nbsp;
              <button onClick={this.stopCapture} id="stop">Stop Capture</button>&nbsp;
              <button onClick={this.screenShotOnline} id="shot">Screenshot</button>
            </p>
            <video ref={this.videoElem} id="video" autoPlay></video>
        </div>
    );
  }
}

export default ScreenShot;